import React, { Fragment } from 'react'
import ScrollToTop from '@myxplor/scroll-to-top'
import Notification from '@myxplor/notifications-redux'
import TopNav from '../top-nav'
import './app-layout.css'

const AppLayout = ({ isEmbedded = false, children }) => (
  <ScrollToTop>
    <Fragment>
      {isEmbedded ? null : (
        <div className="topWrapper">
          <Notification />
          <TopNav />
        </div>
      )}
      {children}
    </Fragment>
  </ScrollToTop>
)

export default AppLayout



// WEBPACK FOOTER //
// ./src/layout/app-layout/index.jsx